import { axiosInstance } from '../config/axios';

// Signed upload to Cloudinary; returns the file's secure URL.
export async function uploadToCloudinary(file, folder) {
  const resourceType = file.type?.startsWith('image/') ? 'image' : 'raw';
  const sig = (await axiosInstance.get(
    `/cloudinary/signature?resource_type=${resourceType}&folder=${encodeURIComponent(folder)}`
  )).data;
  const form = new FormData();
  form.append('file', file);
  form.append('api_key', sig.api_key);
  form.append('timestamp', sig.timestamp);
  form.append('signature', sig.signature);
  form.append('folder', sig.folder);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resourceType}/upload`,
    { method: 'POST', body: form });
  if (!res.ok) throw new Error('Upload failed');
  return (await res.json()).secure_url;
}
